/** Простая модалка с одним текстовым полем — создать/переименовать телефон или модель. */
import { useState, type FormEvent } from 'react';
import { ModalPortal } from './ModalPortal.js';

interface Props {
  title: string;
  label: string;
  initial?: string;
  submitLabel?: string;
  /** Разрешить пустое значение (очистка поля, например серийника). */
  allowEmpty?: boolean;
  onClose: () => void;
  onSubmit: (name: string) => Promise<void>;
}

export function NameModal({ title, label, initial = '', submitLabel = 'Сохранить', allowEmpty = false, onClose, onSubmit }: Props) {
  const [name, setName] = useState(initial);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function submit(e: FormEvent) {
    e.preventDefault();
    if (!name.trim() && !allowEmpty) return;
    setBusy(true);
    setErr(null);
    try {
      await onSubmit(name.trim());
      onClose();
    } catch (e) {
      setErr(e instanceof Error ? e.message : 'Не получилось');
      setBusy(false);
    }
  }

  return (
    <ModalPortal>
    <div className="modal-backdrop" onClick={busy ? undefined : onClose}>
      <div className="modal-panel" onClick={(e) => e.stopPropagation()}>
        <div className="modal-title">{title}</div>
        <form onSubmit={submit} style={{ display: 'grid', gap: 10 }}>
          <label className="field">
            <span>{label}</span>
            <input className="admin-input" autoFocus required={!allowEmpty} value={name} onChange={(e) => setName(e.target.value)} />
          </label>
          {err && <div className="error">{err}</div>}
          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 4 }}>
            <button type="button" className="btn-secondary" onClick={onClose} disabled={busy}>Отмена</button>
            <button type="submit" className="btn-primary" disabled={busy} style={{ width: 'auto', padding: '0 20px' }}>
              {busy ? '…' : submitLabel}
            </button>
          </div>
        </form>
      </div>
    </div>
    </ModalPortal>
  );
}
